export enum WorkflowUserDepartmentInclusionType {
  All = 'ALL',
  Exclude = 'EXCLUDE',
  Include = 'INCLUDE',
}
